export default __webpack_public_path__ + "static/media/Oscer-Privacy-Policy.ebf5d075.pdf";